import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import roles from '@data/_roles.js'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: '/admin-users',
        name: 'admin-users',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/admin-users',
        children: [
          {
            name: '',
            path: '/admin-users',
            component: () => import('@/views/users/index'),
            props: {
              roles: roles.admin_roles,
              routeBase: 'admin-users',
            },
          },
          {
            name: 'admin-users-create',
            path: '/admin-users/create',
            component: () => import('@/views/users/create'),
            props: {
              roles: roles.admin_roles,
              routeBase: 'admin-users',
            },
          },
          {
            name: 'admin-users-edit',
            path: '/admin-users/:id/edit',
            component: () => import('@/views/users/edit'),
            props: {
              roles: roles.admin_roles,
              routeBase: 'admin-users',
            },
          },
          {
            name: 'admin-users-show',
            path: '/admin-users/:id/show',
            component: () => import('@/views/users/show'),
          },
        ],
      },
      {
        path: '/seller-users',
        name: 'seller-users',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/seller-users',
        children: [
          {
            name: '',
            path: '/seller-users',
            component: () => import('@/views/users/index'),
            props: {
              roles: roles.seller_roles,
              routeBase: 'seller-users',
            },
          },
          {
            name: 'seller-users-create',
            path: '/seller-users/create',
            component: () => import('@/views/users/create'),
            props: {
              roles: roles.seller_roles,
              routeBase: 'seller-users',
            },
          },
          {
            name: 'seller-users-edit',
            path: '/seller-users/:id/edit',
            component: () => import('@/views/users/edit'),
            props: {
              roles: roles.seller_roles,
              routeBase: 'seller-users',
            },
          },
          {
            name: 'seller-users-show',
            path: '/seller-users/:id/show',
            component: () => import('@/views/users/show'),
          },
        ],
      },
      {
        path: '/buyer-users',
        name: 'buyer-users',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/buyer-users',
        children: [
          {
            name: '',
            path: '/buyer-users',
            component: () => import('@/views/users/index'),
            props: {
              roles: roles.buyer_roles,
              routeBase: 'buyer-users',
            },
          },
          {
            name: 'buyer-users-create',
            path: '/buyer-users/create',
            component: () => import('@/views/users/create'),
            props: {
              roles: roles.buyer_roles,
              routeBase: 'buyer-users',
            },
          },
          {
            name: 'buyer-users-edit',
            path: '/buyer-users/:id/edit',
            component: () => import('@/views/users/edit'),
            props: {
              roles: roles.buyer_roles,
              routeBase: 'buyer-users',
            },
          },
          {
            name: 'buyer-users-show',
            path: '/buyer-users/:id/show',
            component: () => import('@/views/users/show'),
            props: {
              roles: roles.buyer_roles,
              routeBase: 'buyer-users',
            },
          },
        ],
      },
      {
        path: '/companies',
        name: 'companies',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/companies',
        children: [
          {
            name: 'companies',
            path: '/companies',
            component: () => import('@/views/companies/index'),
          },
          {
            name: 'company-edit',
            path: '/companies/:id/edit',
            component: () => import('@/views/companies/edit'),
          },
          {
            name: 'company-show',
            path: '/companies/:id/show',
            component: () => import('@/views/companies/show'),
          },
        ],
      },
      {
        path: '/categories',
        name: 'categories',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/categories',
        children: [
          {
            name: '',
            path: '/categories',
            component: () => import('@/views/categories/index'),
          },
          {
            name: 'create-category',
            path: '/categories/create',
            component: () => import('@/views/categories/create'),
            props: (route) => ({ parent: route.query.parent }),
          },
          {
            name: 'edit-category',
            path: '/categories/:id/edit',
            component: () => import('@/views/categories/edit'),
            props: (route) => ({ parent: route.query.parent }),
          },
        ],
      },
      {
        path: '/attributes',
        name: 'attributes',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/attributes',
        children: [
          {
            name: '',
            path: '/attributes',
            component: () => import('@/views/attributes/index'),
          },
          {
            name: 'create-attribute',
            path: '/attributes/create',
            component: () => import('@/views/attributes/create'),
          },
          {
            name: 'edit-attribute',
            path: '/attributes/:id/edit',
            component: () => import('@/views/attributes/edit'),
          },
        ],
      },
      {
        path: '/product-variants',
        name: 'product-variants',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/product-variants',
        children: [
          {
            name: '',
            path: '/product-variants',
            component: () => import('@/views/product-variants/index'),
          },
          {
            name: 'show-variant',
            path: '/product-variants/:id/show',
            component: () => import('@/views/product-variants/show'),
          },
          {
            name: 'edit-variant',
            path: '/product-variants/:id/edit',
            component: () => import('@/views/product-variants/edit'),
          },
        ],
      },
      {
        path: '/product-variant-rejection-reasons',
        name: 'product-variant-rejection-reasons',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/product-variant-rejection-reasons',
        children: [
          {
            name: '',
            path: '/product-variant-rejection-reasons',
            component: () =>
              import('@/views/product-variant-rejection-reasons/index'),
          },
          {
            name: 'create-rejection-reason',
            path: '/product-variant-rejection-reasons/create',
            component: () =>
              import('@/views/product-variant-rejection-reasons/create'),
          },
          {
            name: 'edit-rejection-reason',
            path: '/product-variant-rejection-reasons/:id/edit',
            component: () =>
              import('@/views/product-variant-rejection-reasons/edit'),
          },
        ],
      },
      {
        path: '/reviews',
        name: 'reviews',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/reviews',
        children: [
          {
            name: '',
            path: '/reviews',
            component: () => import('@/views/reviews/index'),
          },
          {
            name: 'show-review',
            path: '/reviews/:id/show',
            component: () => import('@/views/reviews/show'),
          },
          {
            name: 'edit-review',
            path: '/reviews/:id/edit',
            component: () => import('@/views/reviews/edit'),
          },
        ],
      },
      {
        path: '/predictive-messages',
        name: 'predictive-messages',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/predictive-messages',
        children: [
          {
            name: '',
            path: '/predictive-messages',
            component: () => import('@/views/predictive-messages/index'),
          },
          {
            name: 'create-predictive-message',
            path: '/predictive-messages/create',
            component: () => import('@/views/predictive-messages/create'),
          },
          {
            name: 'edit-predictive-message',
            path: '/predictive-messages/:id/edit',
            component: () => import('@/views/predictive-messages/edit'),
          },
        ],
      },
      {
        path: '/variant-reports',
        name: 'variant-reports',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/variant-reports',
        children: [
          {
            name: '',
            path: '/variant-reports',
            component: () => import('@/views/variant-reports/index'),
          },
        ],
      },
      {
        path: '/manage-images',
        name: 'manage-images',
        component: {
          render() {
            return h(resolveComponent('router-view'))
          },
        },
        redirect: '/manage-images',
        children: [
          {
            name: 'manage-images',
            path: '/manage-images',
            component: () => import('@/views/manage-images/index'),
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/pages/Login'),
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('@/views/pages/password-reset.vue'),
  },
  {
    path: '/password-reset-confirm',
    name: 'password-reset-confirm',
    component: () => import('@/views/pages/password-reset-confirm.vue'),
  },
  {
    path: '/accept-company-invitation',
    name: 'accept-company-invitation',
    component: () => import('@/views/pages/accept-company-invitation.vue'),
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/pages/email-verification.vue'),
  },
  {
    path: '/open-seller-app',
    name: 'open-seller-app',
    component: () => import('@/views/pages/download-btns.vue'),
  },
  {
    path: '/open-buyer-app',
    name: 'open-buyer-app',
    component: () => import('@/views/pages/download-btns.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page404',
    component: () => import('@/views/pages/Page404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  if (requiresAuth && !loggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
